<div class="main">
  <router-outlet></router-outlet>
</div>

<app-snackbar></app-snackbar>